<template>
  <div
    class="custom-control custom-checkbox"
    :class="{ disabled: disabled, 'form-check-inline': inline }"
  >
    <input
      :id="id"
      class="custom-control-input"
      type="checkbox"
      :disabled="disabled"
      v-model="model"
      @change="toggle"
    />
    <label :for="id" class="custom-control-label">
      <slot>
        <span v-if="inline">&nbsp;</span>
      </slot>
    </label>
  </div>
</template>
<script>


export default {
  name: "base-checkbox",
  model: {
    prop: "checked",
  },
  props: {
    id: {
      type: String,
      description: "Id of checkbox",
    },
    checked: {
      type: [Array, Boolean],
      description: "Whether checkbox is checked",
    },
    disabled: {
      type: Boolean,
      description: "Whether checkbox is disabled",
    },
    inline: {
      type: Boolean,
      description: "Whether checkbox is inline",
    },
  },
  data() {
    return {
      touched: false,
    };
  },
  methods: {
    toggle() {
      this.$emit('change', this.toggle);
    }
  },  
  computed: {
    model: {
      get() {
        return this.checked;
      },
      set(check) {
        if (!this.touched) {
          this.touched = true;
        }
        this.$emit("input", check);
      },
    },
  }
};
</script>
